import React from "react";
import ReportRow from './ReportRow'
import { connect } from 'react-redux';

class Reports extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      success: false,
      running: false,
      failed: false,
      proccess: false
    }
  }

  renderReports = (reports, PLM_project_id) => {
    let reportRows = reports.map((report, i) => {

      return (
        <ReportRow
          report={report}
          PLM_project_id={PLM_project_id}
          projectid={this.props.selectedProject.projectid}
          user={this.props.user.id}
          key={this.props.selectedProject.projectid + '-row-' + i}
          settings={this.props.settings}
        />
      )
    });

    return reportRows
  }

  render() {
    const { reports, PLM_project_id } = this.props.config;
    
    return (
      <div className='reports'>
        {
          <table className="table table-link" id="reports">
            <thead>
              <tr>
                <th scope="col">Title</th>
                <th scope="col">Description</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {
                reports &&
                this.renderReports(reports, PLM_project_id)
              }
            </tbody>
          </table>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  config: state.requestReportsConfig.data,
  user: state.requestUserDataReducer.data,
  selectedProject: state.getSelectedProjectReducer.data,
  settings: state.requestGeneralSettingsReducer.data
})

export default connect(mapStateToProps)(Reports);